"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LakeMarineris = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var LakeMarineris = (function (_super) {
    __extends(LakeMarineris, _super);
    function LakeMarineris() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.LAKE_MARINERIS,
            cost: 18,
            tr: { oceans: 2 },
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(0); }),
            metadata: {
                cardNumber: '053',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.oceans(2); }),
                description: 'Requires 0° C or warmer. Place 2 ocean tiles.',
                victoryPoints: 2,
            },
        }) || this;
    }
    LakeMarineris.prototype.play = function (player) {
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select space for first ocean'));
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select space for second ocean'));
        return undefined;
    };
    LakeMarineris.prototype.getVictoryPoints = function () {
        return 2;
    };
    return LakeMarineris;
}(Card_1.Card));
exports.LakeMarineris = LakeMarineris;
